import { render, staticRenderFns } from "./TableStudentDebt.vue?vue&type=template&id=4e0a1ed2&scoped=true&"
import script from "./TableStudentDebt.vue?vue&type=script&lang=js&"
export * from "./TableStudentDebt.vue?vue&type=script&lang=js&"
import style0 from "./TableStudentDebt.vue?vue&type=style&index=0&id=4e0a1ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a1ed2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDataTable,VIcon})
